export default "__VITE_ASSET__Dn_OOGax__"